import { render, staticRenderFns } from "./MaintananceComponent.vue?vue&type=template&id=1f63df29&"
import script from "./MaintananceComponent.vue?vue&type=script&lang=js&"
export * from "./MaintananceComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports